import { PButton, PInlineNotification } from "@porsche-design-system/components-react"
import { FormattedMessage, useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import type { InputFieldProps, MultiSelectFieldProps, SelectFieldProps } from "src/components"
import { ButtonGroup, FormLayout, InputField, MultiSelectField, SelectField } from "src/components"
import { addCustomEquipmentMessages } from "./addCustomEquipment.messages"

export interface AddCustomEquipmentProps {
	fields: {
		category: SelectFieldProps
		name: InputFieldProps[]
		tags: MultiSelectFieldProps
	}
	hasSubmitFailed: boolean
	isSubmitting: boolean
	onCancel: () => void
	setHasSubmitFailed: (value: boolean) => void
}

export const AddCustomEquipment = ({
	fields: { category, name, tags },
	hasSubmitFailed,
	isSubmitting,
	onCancel,
	setHasSubmitFailed,
}: AddCustomEquipmentProps) => {
	const { formatMessage } = useIntl()

	return (
		<>
			<FormLayout>
				{name.map((props, index) => (
					<InputField key={index} {...props} />
				))}
				<SelectField {...category} />
				<MultiSelectField {...tags} />

				{hasSubmitFailed && (
					<PInlineNotification
						state="error"
						description={formatMessage(formMessages.errorGeneral)}
						onDismiss={() => {
							setHasSubmitFailed(false)
						}}
					/>
				)}
			</FormLayout>

			<ButtonGroup>
				<PButton type="submit" loading={isSubmitting}>
					<FormattedMessage {...addCustomEquipmentMessages.submitCustomEquipment} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={onCancel}>
					<FormattedMessage {...formMessages.cancel} />
				</PButton>
			</ButtonGroup>
		</>
	)
}
